import { render, staticRenderFns } from "./AsociarEventosForm.vue?vue&type=template&id=0a6a624a&scoped=true&"
import script from "./AsociarEventosForm.vue?vue&type=script&lang=ts&"
export * from "./AsociarEventosForm.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarEventosForm.vue?vue&type=style&index=0&id=0a6a624a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a624a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a6a624a', component.options)
    } else {
      api.reload('0a6a624a', component.options)
    }
    module.hot.accept("./AsociarEventosForm.vue?vue&type=template&id=0a6a624a&scoped=true&", function () {
      api.rerender('0a6a624a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Ruta/AsociarEventosForm.vue"
export default component.exports